import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
interface TwoColumnSectionProps {
  title: string;
  description?: string;
  headerRight?: React.ReactNode;
  leftColumn: React.ReactNode;
  leftColumnLabel: string;
  rightColumn: React.ReactNode;
  rightColumnLabel: string;
}
export const TwoColumnSection = ({
  title,
  description,
  headerRight,
  leftColumn,
  leftColumnLabel,
  rightColumn,
  rightColumnLabel
}: TwoColumnSectionProps) => {
  return <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between gap-3 mb-2">
          <h3 className="text-xl font-medium text-center flex-1">{title}</h3>
          {headerRight ? <div className="shrink-0">{headerRight}</div> : null}
        </div>
        {description && <p className="text-left text-muted-foreground mb-6 text-left text-sm">{description}</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="text-sm font-medium mb-4 text-left">{leftColumnLabel}</h4>
            {leftColumn}
          </div>
          <div>
            <h4 className="text-sm font-medium mb-4 text-left">{rightColumnLabel}</h4>
            {rightColumn}
          </div>
        </div>
      </CardContent>
    </Card>;
};